/**
 * Utilidades para trabajar con colores y variantes del botón
 */

import { ButtonColors, IconFontColor } from '@/shared/types/types';

/**
 * Mapeo de colores de botón a colores de icono por defecto
 */
export const colorIconFromButton: Record<ButtonColors, IconFontColor | IconFontColor> = {
  primary: 'current',
  secondary: 'default',
  tertiary: 'default',
  destructive: 'danger',
  link: 'current',
  ghost: 'brand',
  soft: 'default',
};

/**
 * Obtiene el color del icono basado en el color del botón
 *
 * @param buttonColor - Color del botón
 * @param customColorIcon - Color personalizado del icono (tiene prioridad)
 * @returns Color del icono a usar
 */
export const getIconFontColor = (
  buttonColor: ButtonColors | undefined,
  customColorIcon?: IconFontColor | IconFontColor
): IconFontColor | IconFontColor => {
  if (customColorIcon) {
    return customColorIcon;
  }

  const color = buttonColor || 'primary';
  return colorIconFromButton[color];
};
